import { getProductImage, getRealImageUrl } from "./getProductImage";
import BulbCutout from "../assets/products/topseller-cutouts/3.png";
import DownlightCutout from "../assets/products/topseller-cutouts/9.png";
import PanelCutout from "../assets/products/topseller-cutouts/28.png";
import FloodCutout from "../assets/products/topseller-cutouts/31.png";
import RopeCutout from "../assets/products/topseller-cutouts/35.png";

/* Presentation-only transparent cutouts (already generated for the
   homepage Top Selling section) — used ONLY when the product/category
   has no real Admin-Panel image of its own; a real uploaded image
   always takes priority (see getRealImageUrl below) so replacing an
   image in the Admin Panel is reflected here automatically. Mirrors
   the same keyword logic as utils/getProductImage.js; that shared util
   itself is untouched. The live catalog's categories (downlight, street
   & flood, rope, panel, bulb) map 1:1 onto these 5 files. */
const CUTOUT_MAP = [
  { keywords: ["bulb", "candle"], image: BulbCutout },
  { keywords: ["downlight", "down light", "cob", "smd", "ice light"], image: DownlightCutout },
  { keywords: ["batten", "tube"], image: DownlightCutout },
  { keywords: ["panel"], image: PanelCutout },
  { keywords: ["flood", "street"], image: FloodCutout },
  { keywords: ["rope", "strip", "decorative"], image: RopeCutout },
];

export function getCutoutImage(item) {
  if (!item) return BulbCutout;

  // 1. A real uploaded image always wins — never silently replaced by a
  //    local placeholder just because the category/product name happens
  //    to match one of the keyword buckets below.
  const realUrl = getRealImageUrl(item);
  if (realUrl) return realUrl;

  // 2. No real image yet — use the nicer transparent cutout for known
  //    HLC families.
  const haystack = [item.category, item.subcategory, item.name, item.title, item.sub, item.product]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  const match = CUTOUT_MAP.find(({ keywords }) => keywords.some((kw) => haystack.includes(kw)));
  return match ? match.image : getProductImage(item);
}

export default getCutoutImage;
